//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import memberButton from "./button";
export default {
  components: {
    memberButton: memberButton
  },
  props: {
    memberObj: {
      type: Object,
      default: function _default() {}
    },
    userMemberType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    toPay: function toPay() {
      if (this.memberObj.type === 'customized') {
        this.$emit('showContact');
        this.addBaiduTrackEvent(['_trackEvent', '会员弹窗-联系客户经理', '点击']);
      } else {
        this.$emit('showPanelPay', {
          currentPrice: this.memberObj.price,
          originPrice: this.memberObj.originPrice,
          version: this.memberObj.type
        });
        this.addBaiduTrackEvent(['_trackEvent', "\u4F1A\u5458\u5F39\u7A97-".concat(this.memberObj.type), '点击']);
      }
    }
  }
};